import { PrintCardMenu } from './print-card-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';

export class TheWoodsPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.AlternateGothicNo3d.Regular_400, FONT.Fields.SemiBold_600, FONT.Rubik.SemiBold_600];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/byb6whk.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.Brand];
  }

  variantAssetItemCount(): number {
    return 1;
  }

  shouldStandardizeDominantStrainType(): boolean {
    return true;
  }
}
